export default __webpack_public_path__ + "static/media/ic_error_badge.f5acf815.svg";